/**
 * @private
 */
export default () => {
    const pageTypeService = Shopware.Service().get('cmsPageTypeService');

    pageTypeService.register(
        {
            name: 'cms_faq',
            icon: 'regular-question-circle',
            title: 'acris-faq.cms.pageTypeFaqLayout'
        }
    )
};
